import React from "react"
import mount from "core/mount"
import { LinkButton } from "@kit/design/link-button"
import { Note } from "@kit/design/note"

function UnconfirmedSendAddressBanner({ emailSettingsLink }) {
  return (
    <Note variant="warning" layout="inline">
      <Note.Icon />
      <Note.Content>
        <p>
          <strong>
            One or more sending email addresses needs to be confirmed.
          </strong>{" "}
          Confirm an address to start using it for sending.
        </p>
      </Note.Content>
      <Note.Actions>
        <LinkButton size="small" href={emailSettingsLink} target="_blank">
          Manage email addresses
        </LinkButton>
      </Note.Actions>
    </Note>
  )
}

export { UnconfirmedSendAddressBanner }

mount({ "Account.UnconfirmedSendAddressBanner": UnconfirmedSendAddressBanner })
